import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { HelpersService } from 'src/app/services/helpers.service';
import { ProductsService } from 'src/app/services/products.service';

// TREK 1.18 - Add the selected products (one or many) to an existing collection or a new one (3.7)
// Looks and works like the job card's "Save to a collection": clicking a collection's arrow saves straight away.
@Component({
  selector: 'app-pos-products-add-to-collection',
  templateUrl: './pos-products-add-to-collection.component.html',
  styleUrls: ['./pos-products-add-to-collection.component.scss']
})
export class PosProductsAddToCollectionComponent {

  @Input() collections: any[] = [];          // the store's collections (no "All")
  @Input() currentCollectionId: any = null;  // the collection being viewed, greyed out (3.7.1)
  @Input() productIDs: number[] = [];        // the ticked products (one or many)

  public newCollectionName: string = '';
  public saving: boolean = false;
  public errorMessage: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private productsService: ProductsService,
    private helpersService: HelpersService,
    private translate: TranslateService
  ) { }

  isCurrentCollection(collection): boolean {
    return collection.id === this.currentCollectionId;
  }

  // Arrow next to an existing collection: add the products straight away
  addToCollection(collection) {
    if (this.isCurrentCollection(collection) || this.saving || this.productIDs.length === 0) {
      return;
    }
    this.saving = true;
    this.linkProducts(collection.id);
  }

  canCreate(): boolean {
    return !this.saving && this.productIDs.length > 0 && this.newCollectionName.trim().length > 0;
  }

  // New collection: create it first, the same way the job card does, then add the products
  createAndAdd() {
    if (!this.canCreate()) {
      return;
    }
    this.saving = true;
    this.errorMessage = '';

    var data = {
      collectionName: this.newCollectionName.trim(),
      partnerID: this.helpersService.getPartnerId()
    };
    this.productsService.addProductCollection(data).subscribe((response) => {
      this.linkProducts(response.productCollection.id);
    }, (err) => {
      this.saving = false;
      if (err && err.error && err.error.message == 'COLLECTION_ALREADY_EXISTS') {
        this.errorMessage = this.translate.instant('bikeshop.workshop.jobcard.quote.collection_exists');
      }
    });
  }

  // One LinkProduct call per product, the same endpoint the job card uses.
  // Products already in the collection are skipped by the API (3.7.2).
  linkProducts(collectionId: number) {
    var partnerId = this.helpersService.getPartnerId();
    var calls = this.productIDs.map((productId) => this.productsService.addProductCollectionLink({
      PartnerID: partnerId,
      ProductCollectionID: collectionId,
      InternalProductID: productId,
    }));

    forkJoin(calls).subscribe(() => {
      this.saving = false;
      this.activeModal.close({ collectionId: collectionId });
    }, (err) => {
      // Some may have saved, so close anyway and let the page reload the counts
      this.saving = false;
      this.activeModal.close({ collectionId: collectionId });
    });
  }
}